import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      common: {
        appNamePrefix: 'A',
        appNameMiddle: 'DD',
        appNameSuffix: 'CURACY',
        monthlyUsage: 'Monthly Usage',
        myDocument: 'My Document',
        callfigure: 'callfigure',
        glossaryCheck: 'glossary check',
        sumCheck: 'sum check',
        glossaryExtract: 'glossary extract',
        loading: 'loading...',
        subscription: 'Subscription',
        plan: 'Plan',
        purchase: 'Purchase',
        page: 'Page',
        close: 'Close',
        confirm: 'Confirm',
      },
      confirm: {
        processTablesTitle: 'Confirm process tables?',
        processTablesContent: 'Total numbers from tables will calculate usage. Are you sure you want to proceed?'
      },
      sideMenu: {
        toolsHeader: 'Quality Check Tools',
        glossaryToolsHeader: 'Glossary Tools',
        paymentHeader: 'Payment',
        callFigures: 'Call Figures',
        glossaryCheck: 'Glossary Check',
        accuracyCheck: 'Accuracy Check',
        tableSumsCheck: 'Table Sums Check',
        buildGlossary: 'Build Glossary',
        myGlossary: 'My Glossary',
        importGlossary: 'Import Glossary',
        signOffCheck: 'Sign-Off Check',
        deleteGlossary: 'Delete Glossary',
        cancel: 'Cancel',
        delete: 'Delete',
        confirmDelete: 'Are you sure to delete {{name}}?',
        description: {
          callFigures: 'Call Figures tries to match up figures (i.e. numbers, dates and times) in source text with those in translation text.',
          glossaryCheck: 'Glossary Check tries to match up user defined glossary in source text with those in translation text. it detect instances where glossary terms were translated in a manner inconsistent with the glossary.',
          accuracyCheck: 'Accuracy Check detects sentences for which there is possible under-translation or over-translation.',
          tableSumsCheck: 'Table Sums Check detects summations from PDF tables and verifies that the sums are correct and free from rounding errors.',
          signOffCheck: 'Sign-Off Check detects and annotates monetary amounts and numerical values in documents.'
        }
      },
      appbar: {
        document: 'Document',
      },
      createJob: {
        selectFrom: 'Select from:',
        myGlossary: 'My Glossary',
        pair: 'Pair',
        bilingual: 'Bilingual',
        jobName: 'Job Name',
        start: 'Start',
        download: 'Download',
        statusHint: "* You can check the status and download the results from 'My Document'",
        uploading: 'Uploading quality check job, please wait...',
        submitSuccess: 'Quality check job submit is successful',
        completed: 'Quality check job is completed',
        authFail: 'Authentication failed. Please log in again.',
        serverError: 'Server error. Please try again later.',
        unexpectedError: 'An unexpected error occurred while creating the job.',
        updateInfoFail: 'Update information failed',
        documentTypes: {
          source: 'source',
          target: 'target',
          bilingual: 'bilingual',
        }
      },
      upload: {
        title: 'Upload {{type}} file',
        dropHere: 'Drop a document here',
        uploadA: 'Upload a {{types}}',
        orClick: 'or click HERE to select a file',
        limitations: 'Upload limitations:',
        fileSizeLimit: 'File size limit: {{size}}',
        filePageLimit: 'File page limit: {{pages}} pages',
        fileWordLimit: 'File word limit: {{words}} words',
      },
      qualityCheck: {
        myDocument: 'My Document',
        jobRecord: 'Job Record',
        columns: {
          id: 'ID',
          status: 'Status',
          jobName: 'Job Name',
          checkingMode: 'Checking Mode',
          description: 'Description',
          usage: 'Usage',
          createDate: 'Create Date',
          updateDate: 'Update Date'
        },
        actions: {
          createNew: 'Create New Quality Check Job',
          download: 'Download',
          rename: 'Rename',
          delete: 'Delete',
          actionsHeader: 'Actions',
          confirmDeleteTitle: 'Confirm Delete',
          confirmDeleteContent: 'Are you sure to delete this quality check job?',
          renameSuccess: 'Rename quality check job success',
          deleteSuccess: 'Delete successfully'
        }
      },
      stats: {
        resultStatistic: 'Result statistic',
        total: 'Number of figures looked at by Call Figure:',
        matched: 'Of these, the number of figures that were MATCHED (green highlight)',
        unmatched: 'Remaining UNMATCHED (grey comments), which need to be checked by user',
        saved: 'Work saved by using CallFigure',
        download: 'Download',
        thanks: 'Thank you for using Addcuracy :)'
      },
      refresh: {
        refreshNow: 'Refresh now',
        autoRefreshIs: 'Auto-Refresh is',
        enabled: 'enabled',
        disabled: 'disabled',
        autoRefresh: 'Auto-Refresh',
        lastRefreshTime: 'Last refresh time:',
      },
      glossary: {
        name: 'Name',
        modifyGlossary: 'modify glossary',
        exportGlossary: 'export glossary',
        delete: 'delete',
        english: 'English',
        chinese: 'Chinese',
        new: '+ NEW',
        close: 'Close',
        save: 'Save',
        rowEmpty: 'Row {{indices}} is empty.',
        itemsAdded: '{{count}} items successfully added to glossary "{{name}}"',
        added: 'Added {{count}} items to "{{name}}"',
        modified: 'Modified {{count}} items in "{{name}}"',
        deleted: 'Deleted {{count}} items from "{{name}}"',
        noModification: 'No modification',
        prevPage: 'Previous',
        nextPage: 'Next',
        items: 'items',
        gotoPage: 'Go to page',
        build: {
          title: 'Glossary Extraction Tool',
          description: 'Glossary Extraction Tool tries to build glossary from source and target file.',
          inputText: 'Text',
          inputFile: 'File',
          saveToMyGlossary: 'Save to my glossary',
          glossaryName: 'Glossary Name',
          glossaryNameEmpty: 'Glossary name cannot be empty',
          glossaryNameExist: 'Glossary name already exist',
          generate: 'Generate',
          pending: 'Pending...',
          pendingExtract: 'Pending glossary extract...',
          submitSuccess: 'Extract glossary job submit successfully!',
          submitFail: 'Extract glossary job submit failed!',
          buildSuccess: 'Build glossary success!'
        }
      },
      checkSum: {
        pageTitle: 'Sum Check',
        description: 'Table Sums Check detects summations from PDF tables and verifies that the sums are correct and free from rounding errors.',
        selectRegions: 'Select table regions',
        viewer: {
          back: 'back',
          autodetectRegions: 'Autodetect Regions',
          autodetecting: 'Autodetecting regions...',
          generating: 'Generating tables from PDF...',
          regionsSelected: '{{count}} regions selected',
          clear: 'clear',
          process: 'process',
          loadingPdf: 'Loading PDF...'
        },
        result: {
          extracting: 'Extracting tables from file...',
          bullet1: '* Sums checked are highlighted, with correct sums highlighted in GREEN and incorrect sums highlighted in RED.\n',
          bullet2: '* For vertical sums, the tool guesses which rows are sums, and the tool only checks sums that are the total of CONSECUTIVE numbers immediately above the sum.\n',
          bullet3: '* For horizontal sums, the tool assumes that only columns that have the word "total" or "subtotal" in their heading are sums, and the tool only checks sums that are the total of CONSECUTIVE numbers immediately to the left of the sum.\n',
          bullet4: '* A straightforward approach is taken. The sums are recalculated to ensure they are correct. No change is made to the unhighlighted cells.\n',
          finish: 'finish',
          previewOriginal: 'Preview for Table {{name}}:',
          previewCorrected: 'Preview for corrected Table {{name}}:',
          noSummingErrors: 'No summing errors detected',
          noSumDetected: 'No sum detected',
          thanksTitle: 'Thank you for using CheckSum!\n',
          thanksSubTitle: 'We welcome your feedback and suggestions :)'
        }
      },
      signOffCheck: {
        result: {
          bullet1: '* Amounts are highlighted with different colors: GREEN means the amount was found in a table, RED means not found, YELLOW means it is a calculated difference, and GREY means uncertain match.\n',
          bullet2: '* The tool extracts monetary amounts from paragraphs (e.g., $1,000,000, HK$500 million) and matches them against numbers in Word tables and tab-separated tables.\n',
          bullet3: '* If an amount appears only once for a table row, it may be marked as GREY (uncertain). If the paragraph text matches the table row description well (≥50%), it will be GREEN.\n',
          bullet4: '* YELLOW highlights indicate amounts that are calculated differences between two other amounts found in same row of table (e.g., 2025 Revenue - 2024 Revenue).\n'
        }
      }
    }
  },
  'zh-TW': {
    translation: {
      common: {
        appNamePrefix: 'A',
        appNameMiddle: 'DD',
        appNameSuffix: 'CURACY',
        monthlyUsage: '每月用量',
        myDocument: '我的文件',
        callfigure: '數字檢查',
        glossaryCheck: '術語檢查',
        sumCheck: '加總檢查',
        glossaryExtract: '術語抽取',
        loading: '載入中...',
        subscription: '訂閱',
        plan: '方案',
        purchase: '購買',
        page: '頁',
        close: '關閉',
        confirm: '確認',
      },
      confirm: {
        processTablesTitle: '確認處理表格？',
        processTablesContent: '表格中的數字將計入用量。確定要繼續嗎？'
      },
      sideMenu: {
        toolsHeader: '品質檢查工具',
        glossaryToolsHeader: '術語庫工具',
        paymentHeader: '付款',
        callFigures: '數字檢查',
        glossaryCheck: '術語檢查',
        accuracyCheck: '準確度檢查',
        tableSumsCheck: '表格加總檢查',
        buildGlossary: '建立術語庫',
        myGlossary: '我的術語庫',
        importGlossary: '匯入術語庫',
        signOffCheck: '金額檢查',
        deleteGlossary: '刪除術語庫',
        cancel: '取消',
        delete: '刪除',
        confirmDelete: '確定要刪除 {{name}} 嗎？',
        description: {
          callFigures: '數字檢查嘗試比對原文與譯文中的數字、日期與時間。',
          glossaryCheck: '術語檢查嘗試比對使用者定義的術語，找出不一致的翻譯。',
          accuracyCheck: '準確度檢查用來偵測可能發生漏譯或多譯的句子。',
          tableSumsCheck: '表格加總檢查從 PDF 表格中偵測加總並驗證其正確性與四捨五入誤差。',
          signOffCheck: '金額檢查偵測並標註文件中的金額與數值。'
        }
      },
      appbar: {
        document: '文件',
      },
      createJob: {
        selectFrom: '選擇：',
        myGlossary: '我的術語庫',
        pair: '雙檔',
        bilingual: '雙語檔',
        jobName: '工作名稱',
        start: '開始',
        download: '下載',
        statusHint: "* 可於『我的文件』查看狀態並下載結果",
        uploading: '正在上傳品質檢查工作，請稍候…',
        submitSuccess: '品質檢查工作提交成功',
        completed: '品質檢查工作已完成',
        authFail: '驗證失敗，請重新登入。',
        serverError: '伺服器錯誤，請稍後再試。',
        unexpectedError: '建立工作時發生未知錯誤。',
        updateInfoFail: '更新資訊失敗',
        documentTypes: {
          source: '原文',
          target: '譯文',
          bilingual: '雙語'
        }
      },
      upload: {
        title: '上傳{{type}}檔案',
        dropHere: '將文件拖拉到此處',
        uploadA: '上傳 {{types}}',
        orClick: '或點擊此處選擇檔案',
        limitations: '上傳限制：',
        fileSizeLimit: '檔案大小限制：{{size}}',
        filePageLimit: '頁數上限：{{pages}} 頁',
        fileWordLimit: '字數上限：{{words}} 字',
      },
      qualityCheck: {
        myDocument: '我的文件',
        jobRecord: '工作記錄',
        columns: {
          id: 'ID',
          status: '狀態',
          jobName: '工作名稱',
          checkingMode: '檢查模式',
          description: '描述',
          usage: '用量',
          createDate: '建立時間',
          updateDate: '更新時間'
        },
        actions: {
          createNew: '建立新的品質檢查工作',
          download: '下載',
          rename: '重新命名',
          delete: '刪除',
          actionsHeader: '操作',
          confirmDeleteTitle: '確認刪除',
          confirmDeleteContent: '確定要刪除此品質檢查工作嗎？',
          renameSuccess: '重新命名成功',
          deleteSuccess: '刪除成功'
        }
      },
      stats: {
        resultStatistic: '結果統計',
        total: 'Call Figure 檢視的數字總數：',
        matched: '其中匹配（綠色標示）的數量',
        unmatched: '未匹配（灰色註解），需由使用者檢查的數量',
        saved: '使用 CallFigure 節省的工作量',
        download: '下載',
        thanks: '感謝使用 Addcuracy :)'
      },
      refresh: {
        refreshNow: '立即重整',
        autoRefreshIs: '自動重整',
        enabled: '已啟用',
        disabled: '已停用',
        autoRefresh: '自動重整',
        lastRefreshTime: '上次重整時間：',
      },
      glossary: {
        name: '名稱',
        modifyGlossary: '編輯術語庫',
        exportGlossary: '匯出術語庫',
        delete: '刪除',
        english: '英文',
        chinese: '中文',
        new: '+ 新增',
        close: '關閉',
        save: '儲存',
        rowEmpty: '第 {{indices}} 列為空白。',
        itemsAdded: '已成功新增 {{count}} 筆到術語庫「{{name}}」',
        added: '已新增 {{count}} 筆至「{{name}}」',
        modified: '已修改 「{{name}}」 中的 {{count}} 筆',
        deleted: '已從 「{{name}}」 刪除 {{count}} 筆',
        noModification: '沒有變更',
        prevPage: '上一頁',
        nextPage: '下一頁',
        items: '項',
        gotoPage: '跳至頁數',
        build: {
          title: '術語抽取工具',
          description: '術語抽取工具會從原文與譯文檔案中建立術語清單。',
          inputText: '文字',
          inputFile: '檔案',
          saveToMyGlossary: '儲存到我的術語庫',
          glossaryName: '術語庫名稱',
          glossaryNameEmpty: '術語庫名稱不可為空',
          glossaryNameExist: '術語庫名稱已存在',
          generate: '產生',
          pending: '處理中…',
          pendingExtract: '正在建立術語，請稍候…',
          submitSuccess: '術語抽取已提交！',
          submitFail: '術語抽取提交失敗！',
          buildSuccess: '術語抽取成功！'
        }
      },
      checkSum: {
        pageTitle: '加總檢查',
        description: '表格加總檢查從 PDF 表格中偵測加總並驗證其正確性與四捨五入誤差。',
        selectRegions: '選擇表格區域',
        viewer: {
          back: '返回',
          autodetectRegions: '自動偵測區域',
          autodetecting: '正在自動偵測區域…',
          generating: '正在從 PDF 產生表格…',
          regionsSelected: '已選擇 {{count}} 個區域',
          clear: '清除',
          process: '處理',
          loadingPdf: '載入 PDF…'
        },
        result: {
          extracting: '正在從檔案擷取表格…',
          bullet1: '* 已檢查的加總將被標示；正確為綠色，錯誤為紅色。\n',
          bullet2: '* 垂直加總：工具會推測哪些列為加總，且僅檢查「緊鄰上方的連續數字」之總和。\n',
          bullet3: '* 水平加總：工具假設只有標題包含「total／subtotal」的欄為加總，且僅檢查「緊鄰左側的連續數字」之總和。\n',
          bullet4: '* 採取直接方式：重新計算加總以確認正確性；未標示之儲存格不會被更動。\n',
          finish: '完成',
          previewOriginal: '表格 {{name}} 預覽：',
          previewCorrected: '修正後表格 {{name}} 預覽：',
          noSummingErrors: '未偵測到加總錯誤',
          noSumDetected: '未偵測到加總',
          thanksTitle: '感謝使用 CheckSum！\n',
          thanksSubTitle: '歡迎提供意見與建議 :)'
        }
      },
      signOffCheck: {
        result: {
          bullet1: '* 金額會以不同顏色標示：綠色表示在表格中找到，紅色表示未找到，黃色表示為計算差值，灰色表示不確定匹配。\n',
          bullet2: '* 工具會從段落中提取金額（例如 $1,000,000、HK$500 million），並與 Word 表格和 Tab 分隔表格中的數字進行比對。\n',
          bullet3: '* 若某金額僅在表格某行出現一次，可能標記為灰色（不確定）。若段落文字與表格行描述匹配良好（≥50%），則會標記為綠色。\n',
          bullet4: '* 黃色標示表示該金額是表格中兩個其他金額的計算差值（例如：利潤 = 收入 - 成本）。\n'
        }
      }
    }
  },
  'zh-CN': {
    translation: {
      common: {
        appNamePrefix: 'A',
        appNameMiddle: 'DD',
        appNameSuffix: 'CURACY',
        monthlyUsage: '每月用量',
        myDocument: '我的文档',
        callfigure: '数字检查',
        glossaryCheck: '术语检查',
        sumCheck: '求和检查',
        glossaryExtract: '术语抽取',
        loading: '加载中...',
        subscription: '订阅',
        plan: '方案',
        purchase: '购买',
        page: '页',
        close: '关闭',
        confirm: '确认',
      },
      confirm: {
        processTablesTitle: '确认处理表格？',
        processTablesContent: '表格中的数字将计入用量。确定要继续吗？'
      },
      sideMenu: {
        toolsHeader: '质量检查工具',
        glossaryToolsHeader: '术语库工具',
        paymentHeader: '付款',
        callFigures: '数字检查',
        glossaryCheck: '术语检查',
        accuracyCheck: '准确度检查',
        tableSumsCheck: '表格求和检查',
        buildGlossary: '建立术语库',
        myGlossary: '我的术语库',
        importGlossary: '导入术语库',
        signOffCheck: '金额检查',
        deleteGlossary: '删除术语库',
        cancel: '取消',
        delete: '删除',
        confirmDelete: '确定要删除 {{name}} 吗？',
        description: {
          callFigures: '数字检查尝试比对原文与译文中的数字、日期与时间。',
          glossaryCheck: '术语检查尝试比对用户定义的术语，找出不一致的翻译。',
          accuracyCheck: '准确度检查用于检测可能存在漏译或多译的句子。',
          tableSumsCheck: '表格求和检查从 PDF 表格中检测求和并验证其正确性与四舍五入误差。',
          signOffCheck: '金额检查检测并标注文档中的金额与数值。'
        }
      },
      appbar: {
        document: '文件',
      },
      createJob: {
        selectFrom: '选择：',
        myGlossary: '我的术语库',
        pair: '双档',
        bilingual: '双语档',
        jobName: '任务名称',
        start: '开始',
        download: '下载',
        statusHint: "* 可在『我的文档』查看状态并下载结果",
        uploading: '正在上传质量检查任务，请稍候…',
        submitSuccess: '质量检查任务提交成功',
        completed: '质量检查任务已完成',
        authFail: '认证失败，请重新登录。',
        serverError: '服务器错误，请稍后再试。',
        unexpectedError: '创建任务时发生未知错误。',
        updateInfoFail: '更新信息失败',
        documentTypes: {
          source: '原文',
          target: '译文',
          bilingual: '双语'
        }
      },
      upload: {
        title: '上传{{type}}文件',
        dropHere: '将文档拖拽到此处',
        uploadA: '上传 {{types}}',
        orClick: '或点击此处选择文件',
        limitations: '上传限制：',
        fileSizeLimit: '文件大小限制：{{size}}',
        filePageLimit: '页数上限：{{pages}} 页',
        fileWordLimit: '字数上限：{{words}} 字',
      },
      qualityCheck: {
        myDocument: '我的文档',
        jobRecord: '任务记录',
        columns: {
          id: 'ID',
          status: '状态',
          jobName: '任务名称',
          checkingMode: '检查模式',
          description: '描述',
          usage: '用量',
          createDate: '创建时间',
          updateDate: '更新时间'
        },
        actions: {
          createNew: '新建质量检查任务',
          download: '下载',
          rename: '重命名',
          delete: '删除',
          actionsHeader: '操作',
          confirmDeleteTitle: '确认删除',
          confirmDeleteContent: '确定要删除此质量检查任务吗？',
          renameSuccess: '重命名成功',
          deleteSuccess: '删除成功'
        }
      },
      stats: {
        resultStatistic: '结果统计',
        total: 'Call Figure 检查的数字总数：',
        matched: '其中匹配（绿色标示）的数量',
        unmatched: '未匹配（灰色注释），需要用户检查的数量',
        saved: '使用 CallFigure 节省的工作量',
        download: '下载',
        thanks: '感谢使用 Addcuracy :)'
      },
      refresh: {
        refreshNow: '立即刷新',
        autoRefreshIs: '自动刷新',
        enabled: '已启用',
        disabled: '已停用',
        autoRefresh: '自动刷新',
        lastRefreshTime: '上次刷新时间：',
      },
      glossary: {
        name: '名称',
        modifyGlossary: '编辑术语库',
        exportGlossary: '导出术语库',
        delete: '删除',
        english: '英文',
        chinese: '中文',
        new: '+ 新增',
        close: '关闭',
        save: '保存',
        rowEmpty: '第 {{indices}} 行为空。',
        itemsAdded: '已成功新增 {{count}} 条至术语库“{{name}}”',
        added: '已新增 {{count}} 条至“{{name}}”',
        modified: '已修改 “{{name}}” 中的 {{count}} 条',
        deleted: '已从 “{{name}}” 删除 {{count}} 条',
        noModification: '没有变更',
        prevPage: '上一页',
        nextPage: '下一页',
        items: '项',
        gotoPage: '跳至页数',
        build: {
          title: '术语抽取工具',
          description: '术语抽取工具会从原文与译文文件中建立术语清单。',
          inputText: '文本',
          inputFile: '文件',
          saveToMyGlossary: '保存到我的术语库',
          glossaryName: '术语库名称',
          glossaryNameEmpty: '术语库名称不能为空',
          glossaryNameExist: '术语库名称已存在',
          generate: '生成',
          pending: '处理中…',
          pendingExtract: '正在建立术语，请稍候…',
          submitSuccess: '术语抽取已提交！',
          submitFail: '术语抽取提交失败！',
          buildSuccess: '术语抽取成功！'
        }
      },
      checkSum: {
        pageTitle: '求和检查',
        description: '表格求和检查从 PDF 表格中检测求和并验证其正确性与四舍五入误差。',
        selectRegions: '选择表格区域',
        viewer: {
          back: '返回',
          autodetectRegions: '自动检测区域',
          autodetecting: '正在自动检测区域…',
          generating: '正在从 PDF 生成表格…',
          regionsSelected: '已选择 {{count}} 个区域',
          clear: '清除',
          process: '处理',
          loadingPdf: '加载 PDF…'
        },
        result: {
          extracting: '正在从文件提取表格…',
          bullet1: '* 已检查的求和会被高亮；正确为绿色，错误为红色。\n',
          bullet2: '* 垂直求和：工具会猜测哪些行为求和，且仅检查"紧邻上方的连续数字"的总和。\n',
          bullet3: '* 水平求和：工具假设只有标题包含"total／subtotal"的列为求和，且仅检查"紧邻左侧的连续数字"的总和。\n',
          bullet4: '* 采取直接方式：重新计算求和以确认正确性；未高亮的单元格不会被更动。\n',
          finish: '完成',
          previewOriginal: '表格 {{name}} 预览：',
          previewCorrected: '修正后表格 {{name}} 预览：',
          noSummingErrors: '未检测到求和错误',
          noSumDetected: '未检测到求和',
          thanksTitle: '感谢使用 CheckSum！\n',
          thanksSubTitle: '欢迎提供意见与建议 :)'
        }
      },
      signOffCheck: {
        result: {
          bullet1: '* 金额会以不同颜色标示：绿色表示在表格中找到，红色表示未找到，黄色表示为计算差值，灰色表示不确定匹配。\n',
          bullet2: '* 工具会从段落中提取金额（例如 $1,000,000、HK$500 million），并与 Word 表格和 Tab 分隔表格中的数字进行比对。\n',
          bullet3: '* 若某金额仅在表格某行出现一次，可能标记为灰色（不确定）。若段落文字与表格行描述匹配良好（≥50%），则会标记为绿色。\n',
          bullet4: '* 黄色标示表示该金额是表格中两个其他金额的计算差值（例如：利润 = 收入 - 成本）。\n'
        }
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh-TW', 'zh-CN'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'cookie', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

export default i18n;
